/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('ProjectBoard', ProjectBoard);

    ProjectBoard.$inject = ['$resource', 'DateUtils'];

    function ProjectBoard ($resource, DateUtils) {
        var resourceUrl =  'api/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertLocalDateFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertLocalDateFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.fromDate = DateUtils.convertLocalDateToServer(copy.fromDate);
                    copy.untilDate = DateUtils.convertLocalDateToServer(copy.untilDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
